import React, {useState, useEffect}  from 'react';
import { Icon } from '@iconify/react';
import NormalIcon from './StockItems/NormalIcon';
import WrappedExit from './WrappedExit';

function App(props) {


  var homeButton = props.homeButton;
  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var currentPage = props.currentPage;
  var getHistoryWithDefaults = props.getHistoryWithDefaults;
  var logInState = props.logInState;
  var addToExtraScreen = props.addToExtraScreen;
  var currentSStep = props.currentSStep;
  var changeShowWhat = props.changeShowWhat;
  var centerZoom = props.centerZoom;

  var screenSize = props.screenSize;
  var setScreenSize = props.setScreenSize;
  var clickUndoRedo = props.clickUndoRedo;
  var isConnected = props.isConnected;
  var canUndo = props.canUndo;
  var canRedo = props.canRedo;
  var saveState = props.saveState;
  var isShowDatabase = props.isShowDatabase;
  var setIsShowDatabase = props.setIsShowDatabase;
  var doingWhat = props.doingWhat;
  var error = props.error;

  var zoom = props.zoom;
  var setZoom = props.setZoom;
  var isGone = props.isGone;
  var clickBack = props.clickBack;

  const [isEditProgramName, setIsEditProgramName] = useState(false);
  const [tempProgName, setTempProgName] = useState('');
  const [showMenu, setShowMenu] = useState(false);
  useEffect(()=>{
    setIsEditProgramName(false);
  }, [currentPage]);


  var programName;
  if (currentList){
    if (currentList._g){
      programName = currentList._g._programName;
    }
  }


  var headerPiece;
  if (isGone){

  }else if (!isEditProgramName){
    function clickHead(e){
      setTempProgName(programName);
      setIsEditProgramName(true);
    }

    var programNameShow = programName;
    if (programName.length > 25){
      programNameShow = programName.substr(0, 25) + '...';
    }

    headerPiece = <span className='selectText' onClick={clickHead} style={{cursor:'pointer', paddingLeft:'10px', fontSize:'1.5em'}}>{programNameShow}<NormalIcon icon='bi:pencil' width='20px' title='Edit project name'/> </span>
//
//<div onClick={c1} className="cursorpoint"></div>
  }else{
    function onChange(e){
      setTempProgName(e.target.value);
    }

    function onInputKeyDown(e){
      if (e.keyCode === 13){
        if (tempProgName){
          var changes = [{t:'w',w:['_g', '_programName'],n:tempProgName}];
          organicChanges(changes);
          setIsEditProgramName(false);
          getHistoryWithDefaults();
        }else{
          window.alert('Program name cannot be blank');
        }
      }
    }  

    headerPiece = <input autoFocus className='inputBoxClassLong' value={tempProgName} onChange={onChange} onKeyDown={onInputKeyDown} style={{width:"30%"}} placeholder='Program Name' />
  }


//
  function toggleMenu(){
    setShowMenu(!showMenu);
  }

  var screenSizes = [
    {t:'Extra Small Devices (Portrait Phones, less than 576px)', n:0, i:'bx:mobile'},
    {t:'Small Devices (Landscape Phones, 576px and up)', n:1, i:':bx:mobile-landscape'},
    {t:'Medium Devices (Tablets, 768px and up)', n:2, i:'fa:tablet'},
    {t:'Large Devices (Desktops, 992px and up)', n:3, i:'fa:laptop'},
    {t:'Extra Large Devices (Large Desktops, 1200px and up)', n:4, i:'fa:desktop'}];

  function clickScreenSize(n){
    return function(e){
      setScreenSize(n);
    }
  }
  var procScreenSizes = screenSizes.map((aS, index)=>{
    var highlight = false;
    if (screenSize === aS.n){
      highlight = true;
    }
    return {t:aS.t, i:aS.i, f:clickScreenSize(aS.n), highlight}
  })

  function changeZoom(amt){
    return function(e){
      setZoom(zoom + amt, screenSize);
    }
  }

  if (currentSStep === 'edit'){
    procScreenSizes.push({t:'Zoom In', i:'ri:zoom-in-line', f:changeZoom(1)});
    procScreenSizes.push({t:'Zoom Out', i:'ri:zoom-out-line', f:changeZoom(-1)});
    procScreenSizes.push({t:'Center', i:'material-symbols:center-focus-strong', f:centerZoom});
    procScreenSizes.push({t:(canUndo ? 'Undo' : 'Nothing to Undo'), i:'ci:undo', f:(canUndo ? clickUndoRedo('un') : null)});
    procScreenSizes.push({t:(canRedo ? 'Redo' : 'Nothing to Redo'), i:'ci:redo', f:(canRedo ? clickUndoRedo('re') : null)});
  }else if (currentSStep === 'pr'){
    function toggleDatabase(val){
      return function(e){
        if (isShowDatabase === val){
          setIsShowDatabase(false);
        }else{
          setIsShowDatabase(val);
        }
      }
    }
    // procScreenSizes.push({t:'Database',i:'charm:database',highlight:isShowDatabase === 'client', f:toggleDatabase('client')})
    procScreenSizes.push({t:'Variables',i:'carbon:value-variable',highlight:isShowDatabase === 'variables', f:toggleDatabase('variables')})
    procScreenSizes.push({t:'Url Parameters',i:'arcticons:urlsanitizer',highlight:isShowDatabase === 'url', f:toggleDatabase('url')})
  }
  const show = (showMenu) ? "show" : "" ;
// {t:'Save', i:'fluent:save-20-regular', f:clickSave},                           

  var rightCols = procScreenSizes;

  var it = rightCols.map((aRightCol, index)=>{
    var className = '';
    var onClick = aRightCol.f;
    if (aRightCol.highlight){
      className = 'normalIconBlack';
    }
    if (!aRightCol.f){
      onClick = function(e){};
      className = 'normalIconDisabled';
    }
    return <NormalIcon icon={aRightCol.i} onClick={onClick} title={aRightCol.t} style={{marginLeft:'10px'}} className={className}/>
  })

  var launchPiece;
  if (currentSStep === 'edit'){

    var extraStyle = {};
    if (doingWhat && doingWhat.t === 'guide' && doingWhat.v === 6){
      if (!error){
        extraStyle.border = '1px solid blue';
        extraStyle.color = 'blue';
      }
    }

    var launchClick = changeShowWhat('de');

    launchPiece = <span className='topMenu' onClick={launchClick}><Icon width={'25px'} tipLoc='left' icon='bx:rocket'  isBrightWhenLit={true}/>&nbsp;&nbsp;Launch</span>
//
  }else if (currentSStep === 'pr'){
    // changeShowWhat('edit' )
    launchPiece = <div style={{display:'inline-block'}}><WrappedExit clickBack={clickBack}/></div>
//
  }else if (currentSStep === 'de'){
    launchPiece = <span className='topMenu' onClick={changeShowWhat('edit')}><Icon width = "25" icon="bx:rocket" />&nbsp;&nbsp;Exit Launch Mode</span>

  }
//
//
  var errorLine;
  if (saveState){
    var saveText;
    if (saveState === 1){
      saveText = 'Saving...';
    }else if (saveState === 2){
      saveText = 'Saved';
    }else if (saveState === 3){
      saveText = 'Failed to save; please check your internet connection. Retrying... ';
    }
    errorLine = <span style={{paddingLeft:'10px'}}>{saveText}</span>
//
//
  }else if (!isConnected){
    errorLine = <span style={{marginLeft:'4px'}}>No Internet Connection</span>
//
  }else if (!logInState){

    function clickLogIn(e){
      addToExtraScreen({t:'signIn'});
    }

    errorLine = <span onClick={clickLogIn} className='selectCellColoured' style={{marginLeft:'4px', cursor:'pointer', borderRadius:3}}>Sign in to save your work</span>
  }

//
//         

  var details;
  if (!isGone){
    details = <div className={"collapse navbar-collapse " + show}>
              <ul className="navbar-nav ml-auto">
                  <li className="nav-item dropdown">
                    {errorLine}
                    {it}
                    {launchPiece}
                  </li>
                </ul>
            </div>
//
  }  

  return <nav className="navbar navbar-expand-lg navbar-custom" style={{padding:'0.5rem', position:'relative', zIndex:1}}>

          <i className="qtip tip-right" data-tip='Home'><div className='normalIcon'><Icon width = "30" icon="ant-design:home-outlined" onClick={homeButton} style={{cursor:'pointer'}}/></div></i>
          {headerPiece}
          <button className="navbar-toggler" type="button" onClick={ toggleMenu }>
            <span className="navbar-toggler-icon"><Icon width = "25" icon="eva:menu-outline" /></span>
          </button>
          
          {details}
      </nav>

}

export default App;
